import { useState, useEffect, useContext } from 'react';

import { PracticeReseveContext } from '../../PracticeReseveContext';

import { PRACTICE_RESERVE_MODE } from '../../../../../models/practice/reserve/mode/PracticeReserveMode';


// 時間選択 
function PracticeReserveTime() {

  const {
    isLoading,
    lessonTermMinute,
    user, trialCount,
    reserveMode,
    instId, instructors, allInstructors,
    calendar,
    lsnMin, setLsnMin,
    isTrial, setIsTrial,
  } = useContext(PracticeReseveContext);

  const [isFirstSelected, setIsFirstSelected] = useState<boolean>(false);

  const [isOpen30, setIsOpen30] = useState<boolean>(true);


  // レッスン時間選択の初期値
  useEffect(() => {
    if(!isFirstSelected && user && trialCount!=null) {
      if(trialCount >= 1) {
        // 15分:無料
        setLsnMin(lessonTermMinute);
        setIsTrial(true);
      } else {
        // 15分:チケット
        setLsnMin(lessonTermMinute);
        setIsTrial(false);
      }

      setIsFirstSelected(true);
    }
  }, [user, trialCount])


  // レッスン時間のoption表示判定
  useEffect(() => {
    let newIsOpen30 = false;
    //--------------------------------------------------
    // 講師の連続空き枠判定
    //--------------------------------------------------
    if(reserveMode === PRACTICE_RESERVE_MODE.DATETIME) {
      // 日時から選ぶ：時間を先に決める並びなので、日時・講師を選んでも上の選択肢を変えない
      //   絞る前の講師一覧で、誰か1人でも30分取れるか
      newIsOpen30 = allInstructors.some((inst: any) => inst.open_term_flg?.term_30);
    } else if(
      instId && instructors &&
      (instructors.find((inst: any) => inst.inst_id == instId))
    ) {
      // 講師選択
      const instructor = instructors.find((inst: any) => inst.inst_id == instId);
      newIsOpen30 = instructor.open_term_flg?.term_30;
    } else {
      // 講師未選択:選択項目のすべての講師確認
      instructors.forEach((inst: any) => {
        if(inst.open_term_flg?.term_30) {
          newIsOpen30 = true;
        }
      });
    }

    setIsOpen30(newIsOpen30);

    // レッスン時間の選択不可が選択されていた場合
    if(
      // 30分非表示で30分選択の場合：15分選択
      (!newIsOpen30 && lsnMin>=lessonTermMinute*2) ||
      // 1枠も空いていない場合：15分選択
      (calendar && calendar.length==0 && lsnMin!=lessonTermMinute)
    ) {
      setLsnMin(lessonTermMinute);
      setIsTrial(trialCount >= 1);
    }

  }, [trialCount, instructors, allInstructors, calendar, reserveMode])


  // 時間変更
  const handleTime = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    if(!isLoading) {
      const { minute, isTrial } = JSON.parse(e.target.value);
      setLsnMin(parseInt(minute, 10));
      setIsTrial(isTrial);
    }
  }


  return (
    <div>
      <div>
        <label className="control-label" style={{
          margin: '15px 0 10px 0',
          backgroundColor: '#eaf3ff',
          padding: '0.25em 3em 0.25em 0.5em',
          borderLeft: 'solid 5px #516ab6',
        }}>レッスン時間を選択</label>
        <div style={{ marginBottom: '25px' }}>
          <select
            name="lesson_minutes_type"
            className="form-control input-lg"
            id="InputSelect"
            onChange={handleTime}
            value={JSON.stringify({
              minute: lsnMin,
              isTrial: isTrial 
            })}
          >

            {/* 15分/無料 */}
            {trialCount >= 1 &&
              <option value={JSON.stringify({
                minute: lessonTermMinute,
                isTrial: true
              })}>
                {lessonTermMinute}分（無料1回分）
              </option>
            }

            {/* 30分/無料 */}
            {(isOpen30 && trialCount >= 2) &&
              <option value={JSON.stringify({
                minute: lessonTermMinute*2,
                isTrial: true
              })}>
                {lessonTermMinute*2}分（無料2回分）
              </option>
            }


             {/* 15分/チケット */}
            {(
              user?.ticket >= 3 ||
              (user?.ticket<3 && trialCount<=0)
            ) &&
              <option value={JSON.stringify({
                minute: lessonTermMinute,
                isTrial: false
              })}>
                {lessonTermMinute}分（3チケット）
              </option>
            }

            {/* 30分/チケット */}
            {(isOpen30 && user?.ticket>=6) && (
              <option value={JSON.stringify({
                minute: lessonTermMinute*2,
                isTrial: false
              })}>
                {lessonTermMinute*2}分（6チケット）
              </option>
            )}

          </select>
        </div>
      </div>
    </div>
  );
}
  
export default PracticeReserveTime;